import bundleloader from './bundle-loader';

const mods = bundleloader.modules;

export default mods;
